import { SecureInformationRequestFieldType } from '@commenda/prisma';
import { IAddress } from '@commenda/types';
import { FileBasic } from '@commenda/types/src/file/types';
import { ISecureInformationRequestField } from '../secureInformationRequest/types';

export const fieldOrder = [
  SecureInformationRequestFieldType.TEXT,
  SecureInformationRequestFieldType.NUMBER,
  SecureInformationRequestFieldType.BIG_TEXT,
  SecureInformationRequestFieldType.PHONE_NUMBER,
  SecureInformationRequestFieldType.DATE,
  SecureInformationRequestFieldType.RADIO,
  SecureInformationRequestFieldType.ADDRESS,
  SecureInformationRequestFieldType.SELECT,
  SecureInformationRequestFieldType.MULTI_SELECT,
  SecureInformationRequestFieldType.FILE,
  SecureInformationRequestFieldType.MULTI_FILE,
];

export type IStateSecureInformationRequestField =
  ISecureInformationRequestField & {
    value: string | null;
    selectResponse?: string[];
    files?: FileBasic[];
  };

export type FieldProps = {
  headerText: string;
  isSecure: boolean;
  type: SecureInformationRequestFieldType;
  selectOptions?: string[];
  id: string;
  indexInGroup?: number;
  decryptedValue?: string;
  selectResponse?: string[];
  files?: FileBasic[];
  address?: IAddress;
};

const getSortedFields = (fields: Partial<FieldProps>[]) => {
  return fields.sort((a, b) => {
    return (
      fieldOrder.indexOf(a.type as SecureInformationRequestFieldType) -
      fieldOrder.indexOf(b.type as SecureInformationRequestFieldType)
    );
  });
};

export { getSortedFields };
